import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/toPromise';
import { CustomHttp } from '../shared/custom.http';
import { DPMarket } from './model/dp-market';
import { DPTitle } from './model/dp-title';
import { DPModule } from './model/dp-module';
import { DPTitleBatchRequest } from './model/dp-title-batch-request';
import { ApiConstants } from '../shared/api.constants';
import { GeneralConstants } from '../shared/general.constants';
import {Headers, Http, RequestOptions} from '@angular/http';
import {DatePipe} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';
import { EntityType } from '../common/model/constant';
import { log } from 'console';

@Injectable()
export class DPSubscriptionService {

    public allTitles = [];
    public allMarkets = [];
    public allTitlesMap = {};
    public allMarketsMap = {};

    constructor(private router: Router, private http: CustomHttp,
        private apiConstants: ApiConstants, private customhttp: Http, private generalConstants: GeneralConstants) {
    }

    updateAllSubscriptionCache() {
        this.getAllTitles().then(res => {
            if (!res || !res.subscriptions) {
                return;
            }
            const titles: any = {};
            res.subscriptions.titles.forEach(element => {
                titles[element.parrot_id] = element;
            });
            this.allTitles = res.subscriptions.titles;
            this.allTitlesMap = titles;
        });

        this.getMarkets().then(res => {
            if (!res || !res.subscriptions) {
                return;
            }
            const markets: any = {};
            res.subscriptions.markets.forEach(element => {
                markets[element.iso] = element;
            });
            this.allMarkets = res.subscriptions.markets;
            this.allMarketsMap = markets;
        });
    }

    getTitleMetData(titleId) {
        return this.allTitlesMap[titleId];
    }

    getAllTitles() {
        return this.http.get(this.apiConstants.ALL_TITLES_URL, { body: '' });
    }

    getMarkets() {
        return this.http.get(this.apiConstants.ALL_MARKETS_URL, { body: '' });
    }

    getProducts() {
        return this.http.get(this.apiConstants.ALL_PRODUCT_URL, { body: '' });
    }


    getSubscriptions(account_id: number) {
        return this.http.get(this.apiConstants.getSubscriptionByAccountInternalUrl(account_id), { body: '' });
    }

    deleteTitle(titleId: string, account_id: number) {
        return this.http
            .delete(this.apiConstants.getSubscriptionByAccountRefTitle(account_id, titleId), { body: '' });
    }

    deleteMarket(marketId: number, account_id: number, subscriptionEntityType: EntityType) {
        return this.http.delete(this.apiConstants.deleteSubscriptionByAccountIdAndEntityType(account_id, marketId, subscriptionEntityType), { body: '' });
    }


    deleteModule(moduleId: number, account_id: number) {
        return this.http.delete(this.apiConstants.getSubscriptionByAccountRefModule(account_id, moduleId), { body: '' });
    }

    createAuthorizationHeader(headers: Headers) {
        headers.append('x-auth-token', localStorage.getItem('id_token'));
        headers.append('Content-Type', 'application/json');
        return headers;
    }

    getHelpdeskBaseUrl() {
        return this.apiConstants.HELPDESK_API_URL;
    }

    getBaseUrl() {
        return this.apiConstants.CATALOG_API_URL;
    }

    getDataApIBaseUrl() {
        return this.apiConstants.DATA_API_URL;
    }

    addMarket(market: DPMarket, account_id: number) {
        const bodyValue = {
            'account_id': account_id
        };
        return this.http.post(this.apiConstants.postSubscriptionByAccountRefMarket(account_id, market.id), JSON.stringify(bodyValue));
    }

    addMarkets(account_id: number, marketIds: number[], entityType: EntityType) {
        const bodyValue = {
            'subscriptionRefIds': marketIds
        };
        return this.http.post(this.apiConstants.postMarketSubscriptionByAccountIdAndEntityType(account_id, entityType), JSON.stringify(bodyValue));
    }


    addTitle(title: DPTitle, account_id: number) {
        return this.http.post(this.apiConstants.getSubscriptionByAccountRefTitle(account_id, title.parrot_id), JSON.stringify(title.parrot_id));
    }

    addTitleBatch(titles: DPTitleBatchRequest, account_id: number) {
        // Handle special case where the subscription already exists and return everything else as usual.
        return new Promise((resolve, reject) => {
            this.http.post(`${this.apiConstants.getSubscriptionByAccountUrl(account_id)}/tvtitle`, JSON.stringify(titles))
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    // Check if it is an error for subscription already exists
                    let errorJSON = undefined;
                    if (err._body) {
                        errorJSON = JSON.parse(err._body);
                    }
                    if (errorJSON && errorJSON.error && errorJSON.error && errorJSON.error.message &&
                        errorJSON.error.message === this.generalConstants.getSubscriptionAlreadyExistsMessage()) {
                            resolve({ message: 'Success'});
                    } else {
                        reject(errorJSON || err);
                    }
                });
        });
    }

    addModule(request: DPModule, account_id: number) {
        return this.http.post(`${this.apiConstants.getSubscriptionByAccountUrl(account_id)}/module`, JSON.stringify(request));
    }

    updateModule(rmodule: DPModule, account_id: number, subscriptionId: number) {
        return this.http.put(`${this.apiConstants.getSubscriptionByAccountUrl(account_id)}/module?subscriptionId=${subscriptionId}`, JSON.stringify(rmodule));
    }

}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-subscriptions.service.ts